import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import './styles.css'

class BlogDisplay extends Component {
  static propTypes = {
    type: PropTypes.oneOf(['text']).isRequired,
    content: PropTypes.any.isRequired,
  }

  render() {
    const {
      type,
      content,
    } = this.props

    if (type === 'text'){
      return (
        <div className="blog-text">{content}</div>
      )
    }

    return (
      <div>unsupported blog type</div>
    )
  }
}

export default BlogDisplay



// WEBPACK FOOTER //
// ./src/components/BlogDisplay/index.js